import { render, staticRenderFns } from "./DownloadAndroid.vue?vue&type=template&id=21dfe2fc&scoped=true"
import script from "./DownloadAndroid.vue?vue&type=script&lang=js"
export * from "./DownloadAndroid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dfe2fc",
  null
  
)

export default component.exports